/* eslint-disable camelcase */
export const GP_MODAL_VARIANT_ACKNOWLEDGED = 'acknowledged' as const;

export type GatorProtectAcknowledgedModalSelectedPlan = {
  expire_date: string;
  expire_days: number | null;
  is_trial: boolean;
  shared_hosting_plan: string;
};

export type GatorProtectAcknowledgedModalFields = {
  handleClose: () => void;
  handleRedirect: () => void;
  selectedPlan: GatorProtectAcknowledgedModalSelectedPlan | null | undefined;
};
